<template>
    <div>
        <div class="settings-item" @click="modal = true">
            <div class="icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <g id="profile" transform="translate(-108 -252)">
                        <path
                            id="Vector"
                            d="M4.6,8.87a1.818,1.818,0,0,0-.33,0,4.445,4.445,0,1,1,.33,0Z"
                            transform="translate(115.56 254)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        ></path>
                        <path
                            id="Vector-2"
                            data-name="Vector"
                            d="M1.815,1.373c-2.42,1.62-2.42,4.26,0,5.87a9.766,9.766,0,0,0,10.01,0c2.42-1.62,2.42-4.26,0-5.87A9.812,9.812,0,0,0,1.815,1.373Z"
                            transform="translate(113.345 265.188)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        ></path>
                        <path
                            id="Vector-3"
                            data-name="Vector"
                            d="M0,0H24V24H0Z"
                            transform="translate(132 276) rotate(180)"
                            fill="none"
                            opacity="0"
                        ></path>
                    </g>
                </svg>
            </div>
            <div class="name">
                <span>პროფილი</span>
                <p>პირადი ინფორმაცია</p>
            </div>
            <div class="spacer"></div>
            <button>
                <svg
                    id="arrow-right"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                >
                    <path
                        id="Vector"
                        d="M0,13.2,5.433,7.767a1.655,1.655,0,0,0,0-2.333L0,0"
                        transform="translate(7.425 3.4)"
                        fill="none"
                        stroke="rgba(18,32,43,0.5)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                    />
                    <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M0,0H20V20H0Z"
                        transform="translate(20 20) rotate(180)"
                        fill="none"
                        opacity="0"
                    />
                </svg>
            </button>
        </div>

        <transition name="fade">
            <div class="modals" v-show="modal">
                <div class="modals-inner">
                    <h2 class="modals-inner-title">პროფილი</h2>
                    <button class="modals-inner-closer" @click="modal = false">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12.121"
                            height="12.121"
                            viewBox="0 0 12.121 12.121"
                        >
                            <g
                                id="close-circle"
                                transform="translate(-244.109 -260.109)"
                            >
                                <path
                                    id="Vector"
                                    d="M0,10,10,0"
                                    transform="translate(245.17 261.17)"
                                    fill="none"
                                    stroke="#12202b"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                                <path
                                    id="Vector-2"
                                    data-name="Vector"
                                    d="M10,10,0,0"
                                    transform="translate(245.17 261.17)"
                                    fill="none"
                                    stroke="#12202b"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                            </g>
                        </svg>
                    </button>

                    <ValidationObserver
                        ref="observer"
                        v-slot="{ handleSubmit }"
                    >
                        <form
                            method="post"
                            @submit.prevent="handleSubmit(onSave)"
                            @keyup.enter="handleSubmit(onSave)"
                            class="mt-4"
                        >
                            <div class="row">
                                <ValidationProvider
                                    v-if="!userModel.non_georgian_citizen"
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12"
                                    tag="div"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            data-switch-disabled="false"
                                            name="first_name_ge"
                                            placeholder="სახელი"
                                            autocomplete="off"
                                            v-model="userModel.first_name_ge"
                                        />
                                        <span>ქარ</span>
                                    </div>

                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>

                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12"
                                    tag="div"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            data-switch-disabled="false"
                                            value=""
                                            name="last_name_ge"
                                            autocomplete="off"
                                            placeholder="გვარი"
                                            v-model="userModel.last_name_ge"
                                        />
                                        <span>ქარ</span>
                                    </div>
                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>

                                <ValidationProvider
                                    v-if="!userModel.non_georgian_citizen"
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12"
                                    tag="div"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            value=""
                                            name="first_name"
                                            placeholder="სახელი"
                                            v-model="userModel.first_name"
                                        />
                                        <span>ლათ</span>
                                    </div>

                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12"
                                    tag="div"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            value=""
                                            name="last_name"
                                            placeholder="გვარი"
                                            v-model="userModel.last_name"
                                        />
                                        <span>ლათ</span>
                                    </div>

                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12"
                                    tag="div"
                                >
                                    <div class="col-md-12">
                                        <div
                                            :class="{
                                                'calculator-inpout': true,
                                                'is-invalid': !!errors.length,
                                            }"
                                        >
                                            <input
                                                type="email"
                                                autocomplete="off"
                                                name="email"
                                                placeholder="ელ. ფოსტა"
                                                v-model="userModel.email"
                                            />
                                        </div>
                                    </div>

                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12"
                                    tag="div"
                                >
                                    <h2 class="gender-title">სქესი</h2>
                                    <div
                                        class="gender @error('sex') is-invalid @enderror"
                                    >
                                        <label for="gender1">
                                            <input
                                                type="radio"
                                                name="sex"
                                                id="gender1"
                                                value="female"
                                                v-model="userModel.sex"
                                            />
                                            <div class="box"></div>
                                            <span>მდედრობითი</span>
                                        </label>
                                        <label for="gender2">
                                            <input
                                                type="radio"
                                                name="sex"
                                                id="gender2"
                                                value="male"
                                                v-model="userModel.sex"
                                            />
                                            <div class="box"></div>
                                            <span>მამრობითი</span>
                                        </label>
                                    </div>

                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required|numeric|min:11|max:11"
                                    class="col-md-12 mt-4"
                                    tag="div"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            name="identification"
                                            autocomplete="off"
                                            type="text"
                                            placeholder="პირადი ნომერი"
                                            v-model="userModel.identification"
                                        />
                                    </div>
                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required|numeric|min:9|max:9"
                                    class="col-md-12 mt-4"
                                    tag="div"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="mobile"
                                            v-model="userModel.mobile"
                                            placeholder="მობილური"
                                        />
                                    </div>

                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>

                                <!-- v-if="!delivery" -->

                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12 mt-4"
                                    tag="div"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="address"
                                            v-model="userModel.address"
                                            placeholder="მისამართი"
                                            :disabled="delivery"
                                        />
                                    </div>

                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>

                                    <p
                                        v-if="delivery"
                                        class="pb-4"
                                        style="line-height: 21px; color: red"
                                    >
                                        მისამართის ცვლილება არ არის შესაძლებელი
                                        ვინაიდან თქვენ გაქვთ გააქტიურებული
                                        ადგილზე მიტანა, ადგილზე მიტანის
                                        დასრულების შემდეგ შეძლებთ მისამართის
                                        ცვლილებას.
                                    </p>
                                </ValidationProvider>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12 mt-4"
                                    tag="div"
                                    v-if="userModel.organizationName"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            v-model="userModel.organizationName"
                                            placeholder="ორგანიზაცია"
                                            name="organizationName"
                                        />
                                    </div>
                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    class="col-md-12 mt-4"
                                    tag="div"
                                    v-if="userModel.organizationName"
                                >
                                    <div
                                        :class="{
                                            'calculator-inpout': true,
                                            'is-invalid': !!errors.length,
                                        }"
                                    >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            v-model="
                                                userModel.identification_code
                                            "
                                            placeholder="ს/კოდი"
                                            name="identification_code"
                                        />
                                    </div>
                                    <span
                                        v-if="errors[0]"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors[0] }}</strong>
                                    </span>
                                </ValidationProvider>
                            </div>

                            <button class="calculator-button" type="submit">
                                შენახვა
                            </button>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {
    defineComponent,
    onBeforeMount,
    ref,
    reactive,
    watch,
} from "@vue/composition-api";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useUser } from "../hooks/user";
import Swal from "sweetalert2";

export default defineComponent({
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    setup() {
        const { getUser, userInfo } = useUser();
        const modal = ref(false);
        const delivery = ref(false);
        const userModel = reactive({
            first_name_ge: "",
            first_name: "",
            last_name_ge: "",
            last_name: "",
            email: "",
            sex: "",
            identification: "",
            mobile: "",
            organizationName: "",
            address: "",
            identification_code: "",
            non_georgian_citizen: false,
            user_type: false,
        });

        onBeforeMount(async () => {
            const { data } = await axios({
                url: `/api/delivery/status`,
                method: "GET",
            });

            delivery.value = data.status;

            if (!userInfo.value) {
                await getUser();
            }
            if (userInfo.value) {
                userModel.first_name_ge = userInfo.value.first_name_ge;
                userModel.first_name = userInfo.value.first_name;
                userModel.last_name_ge = userInfo.value.last_name_ge;
                userModel.last_name = userInfo.value.last_name;
                userModel.email = userInfo.value.email;
                userModel.sex = userInfo.value.sex;
                userModel.identification = userInfo.value.identification;
                userModel.mobile = userInfo.value.mobile;
                userModel.address = userInfo.value.address;
                userModel.organizationName = userInfo.value.organizationName;
                userModel.identification_code = userInfo.value.identification;
                userModel.non_georgian_citizen =
                    userInfo.value.non_georgian_citizen;
                userModel.user_type = userInfo.value.user_type;
            }
        });

        const BodyFix = (status) => {
            const body = document.body;

            if (status) {
                body.style.overflow = "hidden";
            } else {
                body.style.overflow = "scroll";
            }
        };

        watch(
            () => modal.value,
            (newVal, OldVal) => {
                BodyFix(newVal);
            }
        );

        const onSave = () => {
            axios({
                method: "post",
                url: "api/profile/update",
                data: userModel,
            })
                .then((e) => {
                    Swal.fire({
                        icon: "success",
                        title: "ინფორმაცია წარმატებით განახლდა",
                        confirmButtonText: "დახურვა",
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                })
                .catch(function (error) {
                    Swal.fire({
                        icon: "error",
                        title: "დაფიქსირდა შეცდომაა",
                        confirmButtonText: "დახურვა",
                    });
                });
        };

        return {
            modal,
            onSave,
            userInfo,
            userModel,
            delivery,
        };
    },
});
</script>
